import { AbstractControl } from "@angular/forms";

export function ValidateBlankText(control: AbstractControl) {

    if (!control.value || control.value.trim().length === 0) {
        return { isBlank: true };
    }

    return null;

}